import React from "react";
import { X } from "lucide-react";

export const Modal = ({ open, onClose, title, children, wide }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50" onClick={onClose}>
      <div className={`bg-white rounded-2xl w-full ${wide ? "max-w-3xl" : "max-w-lg"} max-h-[90vh] overflow-auto`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-stone-200 sticky top-0 bg-white z-10">
          <h3 className="font-bold text-[#1E3A2B] text-lg">{title}</h3>
          <button onClick={onClose} className="p-1.5 hover:bg-stone-100 rounded-lg" data-testid="modal-close"><X size={20} /></button>
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
};

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-sm font-medium text-stone-700">{label}</span>
    <div className="mt-1">{children}</div>
  </label>
);

export const inputCls = "w-full h-11 px-3 rounded-xl border border-stone-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#1E3A2B]/30";

export const StatCard = ({ icon: Icon, label, value, color = "emerald", sub }) => {
  const colors = {
    emerald: "bg-emerald-50 text-emerald-700",
    amber: "bg-amber-50 text-amber-700",
    blue: "bg-blue-50 text-blue-700",
    red: "bg-red-50 text-red-700",
    purple: "bg-purple-50 text-purple-700",
    stone: "bg-stone-100 text-stone-700",
  };
  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${colors[color]}`}><Icon size={22} /></div>
      </div>
      <div className="mt-3 text-2xl font-bold text-[#1C1917]">{value}</div>
      <div className="text-sm text-stone-500">{label}</div>
      {sub && <div className="text-xs text-stone-400 mt-0.5">{sub}</div>}
    </div>
  );
};

export const Th = ({ children, className = "" }) => <th className={`text-left px-3 py-2.5 text-xs font-semibold text-stone-500 uppercase tracking-wide ${className}`}>{children}</th>;
export const Td = ({ children, className = "" }) => <td className={`px-3 py-3 text-sm text-stone-700 ${className}`}>{children}</td>;

export const Empty = ({ text = "কোনো তথ্য নেই" }) => (
  <div className="text-center py-12 text-stone-400">{text}</div>
);

export const fmtDate = (s) => { try { return new Date(s).toLocaleDateString("bn-BD"); } catch { return s; } };
